import React, { createContext, useContext, useEffect, useRef } from 'react'
import { useNavigation, useParams } from 'react-router-dom'
import { useAgreementDetail } from '../../api/documents'
import { AgreementStateProvider } from './use-agreement-state'
import { CreateFormSecondaryNav } from './view/secondary-navigations'
import { IDocuments } from '@reapitform/dashboard-ui'

export const DocumentContext = createContext<IDocuments | null>(null)
export const useDocuments = () => {
  const result = useContext(DocumentContext)
  return result
}

export const ClientProvider: React.FC = () => {
  const { documentId } = useParams<string>()
  const { data: documents, isError, isLoading } = useAgreementDetail(documentId)
  const isFirstRendered = useRef<boolean>(true)
  const isRedirected = useRef<boolean>(false)
  const isLoadingPage: boolean = useNavigation().state === 'loading'

  useEffect(() => {
    isFirstRendered.current = false
  }, [])

  if (isLoading || isError) return null

  if (isLoadingPage && isRedirected.current) return null
  if (!isFirstRendered.current) isRedirected.current = false

  return (
    <DocumentContext.Provider value={documents || null}>
      <AgreementStateProvider>
        <CreateFormSecondaryNav />
      </AgreementStateProvider>
    </DocumentContext.Provider>
  )
}
